import * as LocalAuthBypass from '@shared/local-auth-bypass';

export type LocalAuthBypassRole =
  (typeof LocalAuthBypass.LOCAL_AUTH_BYPASS_ROLES)[number];

const parseBoolean = (value: unknown): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return ['1', 'true', 'yes', 'on'].includes(normalized);
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  return false;
};

export const isLocalAuthBypassEnabled = (): boolean =>
  parseBoolean(
    (import.meta as ImportMeta & {
      env?: Record<string, unknown>;
    }).env?.VITE_LOCAL_AUTH_BYPASS,
  );

export const LOCAL_AUTH_BYPASS_ROLE_OPTIONS =
  LocalAuthBypass.LOCAL_AUTH_BYPASS_ROLES;
